import { Select, MenuItem, FormControl, SelectChangeEvent } from "@mui/material"
import { useState } from "react"
import Btn from "../Btn"

const Search = (): JSX.Element => {
    const [what, setWhat] = useState<string>("Accomodation")
    const [where, setWhere] = useState<string>("")
    const onWhatChange = (e: SelectChangeEvent) => {
        setWhat(e.target.value as string);
    }
    const onWhereChange = (e: SelectChangeEvent) => {
        setWhere(e.target.value as string);
    }
    return (
        <div className="Container w-[calc(100%-2rem)] max-w-[900px] 2xl:max-w-[1000px] xl:grow bg-white rounded-lg  h-fit flex justify-center items-center  mx-2">
            <div className="flex justify-center md:flex-col lg:flex-row flex-wrap gap-4 w-fit p-5 lg:py-14 lg:px-10">
                <div className="What">
                    <FormControl
                        className="w-[250px] sm:min-w-[300px] 2xs:w-[500px] max-w-[500px] md:max-w-[300px]"
                    >
                        <span className="font-bold text-md ml-2">What</span>
                        <Select value={what} onChange={onWhatChange}>
                            <MenuItem value={"Accomodation"}>Accomodation</MenuItem>
                            <MenuItem value={"Transport"}>Transport</MenuItem>
                            <MenuItem value={"Restaurant"}>Restaurant</MenuItem>
                        </Select>
                    </FormControl>
                </div>
                <div className="Where">
                    <FormControl
                        className="w-[250px] sm:min-w-[300px] 2xs:w-[500px] max-w-[500px] md:max-w-[300px]"
                    >
                        <span className="font-bold text-md ml-2">Where</span>
                        <Select value={where} onChange={onWhereChange}>
                            <MenuItem value={"Accomodation"}>Accomodation</MenuItem>
                            <MenuItem value={"Transport"}>Transport</MenuItem>
                            <MenuItem value={"Restaurant"}>Restaurant</MenuItem>
                        </Select>
                    </FormControl>
                </div>
                <Btn noBorderRadius defaultStyle noHoverEffect filled
                    className="rounded w-full max-w-[500px] md:max-w-[300px] lg:w-auto h-fit self-end md:self-start lg:self-end"
                >
                    Search
                </Btn>
            </div>
        </div>
    )
}
export default Search